import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

export const getDefaultState = () => {
    return {
        error: null,
        loading: false,
        data: {
            code: code,
            codeAPI: codeAPI,
            module: {},
            panels: {
                home: {
                    menu: {
                        route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                        text: 'home.title',
                        icon: 'fas fa-home',
                    },
                    acl: {
                        view: 'EPL_00001',
                    },
                },
                settings: {
                    menu: {
                        route: `${code}.settings`,
                        text: `settings.titles`,
                        icon: 'fas fa-cogs',
                    },
                    acl: {
                        view                    : 'EPL_00051',
                        edit                    : 'EPL_00052',
                    },
                    url: {
                        getConfig               : `/${codeAPI}/gestao/definitions`,
                    },
                },
                default_layers: {
                    menu: {
                        route: `${code}.default_layers`,
                        text: 'default_layers.titles',
                        icon: 'fas fa-layer-group',
                    },
                    acl: {
                        view                    : 'EPL_00064',
                        detail                  : 'EPL_00065',
                        add                     : 'EPL_00066',
                        edit                    : 'EPL_00067',
                        delete                  : 'EPL_00068',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/defaultlayers`,
                        getShow                 : `${codeAPI}/gestao/defaultlayers/:id`,
                        getCreate               : `${codeAPI}/gestao/defaultlayers`,
                        getUpdate               : `${codeAPI}/gestao/defaultlayers/:id`,
                        getDelete               : `${codeAPI}/gestao/defaultlayers/:id`,
                        getLists                : `${codeAPI}/gestao/defaultlayers/lists`,
                        getResources            : `${codeAPI}/gestao/defaultlayers/resources`,
                    },
                },
                layers: {
                    menu: {
                        route: `${code}.layers`,
                        text: 'layers.titles',
                        icon: 'fas fa-layer-group',
                    },
                    acl: {
                        view                    : 'EPL_00013',
                        detail                  : 'EPL_00014',
                        add                     : 'EPL_00017',
                        edit                    : 'EPL_00015',
                        delete                  : 'EPL_00016',
                        private                 : 'EPL_00017',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/layers`,
                        getShow                 : `${codeAPI}/gestao/layers/:id`,
                        getCreate               : `${codeAPI}/gestao/layers`,
                        getUpdate               : `${codeAPI}/gestao/layers/:id`,
                        getDelete               : `${codeAPI}/gestao/layers/:id`,
                        getLists                : `${codeAPI}/gestao/layers/lists`,
                        getResources            : `${codeAPI}/gestao/layers/resources`,
                        describeResource        : `${codeAPI}/gestao/layers/resources/:id/describe`,
                    },
                },
                regulations: {
                    menu: {
                        route: `${code}.regulations`,
                        text: 'regulations.titles',
                        icon: 'fas fa-book',
                    },
                    panel: {
                        files: {
                            maxFiles: 1,
                            mimeTypes: [
                                "application/msword",
                                "application/vnd.ms-excel",
                                "application/vnd.ms-powerpoint",
                                "application/pdf",
                                "text/plain",
                                "image/*",
                            ],
                        }
                    },
                    acl: {
                        view                    : 'EPL_00061',
                        detail                  : 'EPL_00060',
                        add                     : 'EPL_00058',
                        edit                    : 'EPL_00059',
                        delete                  : 'EPL_00062',
                    },
                    url: {
                        getList                 : `${codeAPI}/gestao/regulations`,
                        getShow                 : `${codeAPI}/gestao/regulations/:id`,
                        getCreate               : `${codeAPI}/gestao/regulations`,
                        getUpdate               : `${codeAPI}/gestao/regulations/:id`,
                        getDelete               : `${codeAPI}/gestao/regulations/:id`,
                        getLists                : `${codeAPI}/gestao/regulations/lists`,
                    },
                },
                print_visible_emissions: {
                    menu: {
                        route: `${code}.print_visible_emissions.config`,
                        text: 'print_visible_emissions.titles',
                        icon: 'fas fa-print',
                    },
                    acl: {
                        view                    : 'EPL_00056',
                        config                  : 'EPL_00056',
                        configEdit              : 'EPL_00057',
                    },
                    url: {
                        getList                 : `/${codeAPI}/gestao/printvisible`,

                        getConfig               : `/${codeAPI}/gestao/printvisible/settings`,
                        getApps                 : `/${codeAPI}/gestao/printvisible/print/apps`,
                    },
                },
                worktypes: {
                    menu: {
                        route: `${code}.worktypes`,
                        text: 'Naturezas de Obra',
                        icon: 'fas fa-tasks',
                    },
                    acl: {
                        view                    : 'EPL_00003',
                        detail                  : 'EPL_00004',
                        add                     : 'EPL_00007',
                        edit                    : 'EPL_00005',
                        delete                  : 'EPL_00006',
                        config                  : 'EPL_00018',
                        configEdit              : 'EPL_00019',
                    },
                    url: {
                        getList                 : `/${codeAPI}/gestao/worktypes`,
                        getShow                 : `/${codeAPI}/gestao/worktypes/:id`,
                        getCreate               : `/${codeAPI}/gestao/worktypes`,
                        getUpdate               : `/${codeAPI}/gestao/worktypes/:id`,
                        getDelete               : `/${codeAPI}/gestao/worktypes/:id`,
                        getLists                : `/${codeAPI}/gestao/worktypes/lists`,
                        getPlans                : `/${codeAPI}/gestao/worktypes/plans`,

                        getConfig               : `/${codeAPI}/gestao/worktypes/settings`,
                        getApps                 : `/${codeAPI}/gestao/worktypes/print/apps`,
                        getLayouts              : `/${codeAPI}/gestao/worktypes/print/layouts/:appid`,
                        getFormats              : `/${codeAPI}/gestao/worktypes/print/formats/:appid`,
                    },
                },
                plans: {
                    menu: {
                        route: `${code}.plans`,
                        text: 'Mapas',
                        icon: 'fas fa-tasks',
                    },
                    acl: {
                        view                    : 'EPL_00008',
                        detail                  : 'EPL_00009',
                        add                     : 'EPL_00012',
                        edit                    : 'EPL_00010',
                        delete                  : 'EPL_00011',
                        config                  : 'EPL_00020',
                        configEdit              : 'EPL_00021',
                    },
                    url: {
                        getList                 : `/${codeAPI}/gestao/plans`,
                        getShow                 : `/${codeAPI}/gestao/plans/:id`,
                        getCreate               : `/${codeAPI}/gestao/plans`,
                        getUpdate               : `/${codeAPI}/gestao/plans/:id`,
                        getDelete               : `/${codeAPI}/gestao/plans/:id`,
                        getLists                : `/${codeAPI}/gestao/plans/lists`,

                        getConfig               : `/${codeAPI}/gestao/plans/settings`,
                        getApps                 : `/${codeAPI}/gestao/plans/print/apps`,
                        getLayouts              : `/${codeAPI}/gestao/plans/print/layouts/:appid`,
                        getFormats              : `/${codeAPI}/gestao/plans/print/formats/:appid`,
                        getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                    },
                },
                pmd_fcis: {
                    menu: {
                        route: `${code}.pmd_fcis`,
                        text: 'Planos PMDFCI',
                        icon: 'fas fa-tasks',
                    },
                    acl: {
                        view                    : 'EPL_00022',
                        detail                  : 'EPL_00023',
                        add                     : 'EPL_00026',
                        edit                    : 'EPL_00024',
                        delete                  : 'EPL_00025',
                        config                  : 'EPL_00027',
                        configEdit              : 'EPL_00028',
                    },
                    url: {
                        getList                 : `/${codeAPI}/gestao/pmdfcis`,
                        getShow                 : `/${codeAPI}/gestao/pmdfcis/:id`,
                        getCreate               : `/${codeAPI}/gestao/pmdfcis`,
                        getUpdate               : `/${codeAPI}/gestao/pmdfcis/:id`,
                        getDelete               : `/${codeAPI}/gestao/pmdfcis/:id`,
                        getLists                : `/${codeAPI}/gestao/pmdfcis/lists`,

                        getConfig               : `/${codeAPI}/gestao/pmdfcis/settings`,
                        getApps                 : `/${codeAPI}/gestao/pmdfcis/print/apps`,
                        getLayouts              : `/${codeAPI}/gestao/pmdfcis/print/layouts/:appid`,
                        getFormats              : `/${codeAPI}/gestao/pmdfcis/print/formats/:appid`,
                        getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                    },
                },
                pis: {
                    menu: {
                        route: `${code}.pis`,
                        text: 'Pedido Informação Simples',
                        icon: 'fas fa-tasks',
                    },
                    acl: {
                        view                    : 'EPL_00029',
                        detail                  : 'EPL_00030',
                        add                     : 'EPL_00033',
                        edit                    : 'EPL_00031',
                        delete                  : 'EPL_00032',
                        config                  : 'EPL_00034',
                        configEdit              : 'EPL_00035',
                    },
                    url: {
                        getList                 : `/${codeAPI}/gestao/pis`,
                        getShow                 : `/${codeAPI}/gestao/pis/:id`,
                        getCreate               : `/${codeAPI}/gestao/pis`,
                        getUpdate               : `/${codeAPI}/gestao/pis/:id`,
                        getDelete               : `/${codeAPI}/gestao/pis/:id`,
                        getLists                : `/${codeAPI}/gestao/pis/lists`,

                        getConfig               : `/${codeAPI}/gestao/pis/settings`,
                        getApps                 : `/${codeAPI}/gestao/pis/print/apps`,
                        getLayouts              : `/${codeAPI}/gestao/pis/print/layouts/:appid`,
                        getFormats              : `/${codeAPI}/gestao/pis/print/formats/:appid`,
                        getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                    },
                },
            },
            tools: {

            }
        },
    }
};

const state = getDefaultState();

export default state;